const screenResolutions: { [key: string]: string } = {
  desktopS: '1280px',
  tablet: '768px',
  mobile: '420px'
};

export { screenResolutions };
